import type { CharacteristicValueType } from '@/types'
import api from '@/utils/api/api'

export interface CharacteristicDetailsValue {
  id: string
  value: string
}

export interface CharacteristicDetailsCharacteristic {
  id: string
  code: number
  description: string
  valueType: CharacteristicValueType
  status: 'DRAFT' | 'APPROVED' | 'REJECTED'
  useUnitOfMeasurement: boolean
  unitOfMeasurementDto?: {
    id?: string
    code?: string
    description?: string
  } | null
}

export interface CharacteristicDetailsResponse {
  characteristic: CharacteristicDetailsCharacteristic
  items: CharacteristicDetailsValue[]
}

const resultCache = new Map<string, CharacteristicDetailsResponse>()
const pendingRequests = new Map<
  string,
  Promise<CharacteristicDetailsResponse>
>()

export function fetchCharacteristicDetails(
  id: string
): Promise<CharacteristicDetailsResponse> {
  const cached = resultCache.get(id)
  if (cached) return Promise.resolve(cached)

  const pending = pendingRequests.get(id)
  if (pending) return pending

  const request = api
    .get<{
      characteristic: CharacteristicDetailsCharacteristic
      items?: CharacteristicDetailsValue[]
    }>(`/main/characteristics/${id}`)
    .then((response) => {
      const result: CharacteristicDetailsResponse = {
        characteristic: response.data.characteristic,
        items: response.data.items ?? [],
      }
      resultCache.set(id, result)
      return result
    })
    .finally(() => {
      pendingRequests.delete(id)
    })

  pendingRequests.set(id, request)
  return request
}

export function invalidateCharacteristicDetails(id: string) {
  resultCache.delete(id)
}
